import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';
import WizardStatus from 'feature/dispatching/components/WizardStatus';
import { useEditLoadMutation } from '../loadsEndpoints';
import transformLoad from '../components/wizard/transformLoad';

const ConfirmationStep = ({ reset, onClose, onSaved, children, loadState }) => {
  const [submit, { isLoading, isSuccess, isError, error }] = useEditLoadMutation();

  useEffect(() => {
    const load = transformLoad(loadState);
    submit({ load }).unwrap().then(onSaved);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button disabled={false} onClick={reset} sx={{ width: 150 }} variant="outlined">
        New Load
      </Button>
      <Button disabled={false} onClick={onClose} sx={{ width: 150 }}>
        Done
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      isLoading={isLoading}
      onHeaderButtonClick={onClose}
      title="Edit Load"
    >
      <ProgressBar label="Confirmation (4 of 4)" value={100} />
      <WizardStatus
        error={error}
        isError={isError}
        isSuccess={isSuccess}
        successMessage="To create another load with the same driver, trailer, and location click the New Load button below."
      />
      {children}
    </DrawerLayoutWrapper>
  );
};

ConfirmationStep.propTypes = {
  children: PropTypes.node.isRequired,
  loadState: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
};

export default ConfirmationStep;
